import Vue from 'vue'
import Router from 'vue-router'
import utils from '@/utils';
// import Mine from '../views/MineView/Mine'

// const Mine = () => import('views/MineView/Mine')

// const originalPush = Router.prototype.push

// Router.prototype.push = function push(location) {  
//   return originalPush.call(this, location).catch(err => err)
// }


Vue.use(Router)

let routes = [
  // {
  //   path:"/index.html",
  //   redirect: "/rebate"
  // },
  // {
  //   path:"/",
  //   redirect: "/"
  // },
]


export default new Router({
  routes,
  mode: 'history',// 模式，避免地址栏显示多余的#
  linkActiveClass: "router-active" //当前选中的 router-link 的class的值，可以用于在style中设置这个class name,展示不同的选中状态
})



// WEBPACK FOOTER //
// ./src/router/index.js